export enum FieldTypeEnum {
  INPUT,
  TEXTAREA,
}
